import { render, staticRenderFns } from "./GridCollapseModV2.vue?vue&type=template&id=640c95f6&scoped=true"
import script from "./GridCollapseModV2.vue?vue&type=script&lang=js"
export * from "./GridCollapseModV2.vue?vue&type=script&lang=js"
import style0 from "./GridCollapseModV2.vue?vue&type=style&index=0&id=640c95f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640c95f6",
  null
  
)

export default component.exports